import { NavLink } from "react-router-dom";
import {
  FaHome,
  FaUserAlt,
  FaCalendarCheck,
} from "react-icons/fa";
import {
  MdAddBox,
  MdDashboardCustomize,
  MdInfo,
  MdOutlineSecurity,
  MdPrivacyTip,
  MdSettings,
} from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { useEffect, useMemo, useState } from "react";
import Navbar from "../../Navbar/Navbar";
import AuthService from "../../../modules/Admin/services/AuthService";
import { isModuleEnabled } from "../../utils/moduleAccessStore";
import { PRODUCT_DISPLAY_NAME } from "../../constants/branding";

const routes = [
  { path: "/dashboard", name: "Dashboard", icon: <FaHome />, moduleKey: "dashboard" },

  { path: "/leadassigned", name: "Assigned Leads", icon: <MdAddBox />, moduleKey: "assignedLeads" },
  { path: "/kanban", name: "Kanban Pipeline", icon: <MdDashboardCustomize />, moduleKey: "kanban" },

  { path: "/pendingfollowups", name: "Pending FollowUps", icon: <FaUserAlt />, moduleKey: "pendingFollowUps" },

  { path: "/attendance", name: "My Attendance", icon: <FaCalendarCheck />, moduleKey: "attendance" },
  { path: "/settings", name: "Settings", icon: <MdSettings />, moduleKey: "settings" },
  { path: "/quicksupport", name: "Quick Support", icon: <FaPhoneSquareAlt />, moduleKey: "quickSupport" },
  {
    path: "/about",
    name: "About",
    icon: <MdInfo />,
  },
  {
    path: "/privacy",
    name: "Privacy",
    icon: <MdPrivacyTip />,
  },
  {
    path: "/termsandconditions",
    name: "Terms and Conditions",
    icon: <MdOutlineSecurity />,
  },
];
const SideBar = ({ children }) => {
  const [isOpen] = useState(true);
  const [menuSearch, setMenuSearch] = useState("");
  const roleNum = parseInt(AuthService.getLoggedInRoleId(), 10);
  const EMPLOYEE_ROLE_ID = 4;
  const visibleRoutes =
    roleNum === 1
      ? routes
      : routes.filter((r) => {
          if (roleNum === EMPLOYEE_ROLE_ID && r.path === "/settings") return false;
          return !r.moduleKey || isModuleEnabled(r.moduleKey);
        });

  const filteredRoutes = useMemo(() => {
    const q = menuSearch.trim().toLowerCase();
    if (!q) return visibleRoutes;
    return visibleRoutes.filter((r) => r.name.toLowerCase().includes(q));
  }, [visibleRoutes, menuSearch]);
  const [agency, setAgency] = useState(null);
  const ClientId = AuthService.getLoggedInClientId();

  useEffect(() => {
    async function getAgencyLogoByClientId() {
      try {
        const response =
          await AuthService.getAgencyLogoAndNameByClientId(ClientId);
        setAgency(response);
      } catch (error) {
        console.error("Error fetching agency:", error);
      }
    }
    getAgencyLogoByClientId();
  }, [ClientId]);

  const closeSidebar = () => {
    document.body.classList.remove("sidebar-open");
  };

  return (
    <>
      <div
        className="sidebar-backdrop"
        onClick={closeSidebar}
        aria-hidden="true"
      />
      <aside
        className="sidenav navbar navbar-vertical navbar-expand-xs border-radius-lg fixed-start ms-2 my-2"
        id="sidenav-main"
      >
        <div className="sidenav-header">
          <i
            className="fas fa-times p-3 cursor-pointer text-white opacity-6 position-absolute end-0 top-0 d-none d-xl-none"
            aria-hidden="true"
            id="iconSidenav"
          ></i>
          <NavLink
            className="navbar-brand nf-sidebar-brand"
            to="/dashboard"
            onClick={closeSidebar}
          >
            <span className="nf-sidebar-brand-name">{PRODUCT_DISPLAY_NAME}</span>
            {agency?.agencyName ? (
              <span className="nf-sidebar-brand-sub">{agency.agencyName}</span>
            ) : null}
          </NavLink>
        </div>
        <div className="nf-sidebar-search-wrap">
          <div className="nf-sidebar-search">
            <i className="fas fa-search nf-sidebar-search-icon" aria-hidden="true" />
            <input
              type="search"
              className="nf-sidebar-search-input"
              placeholder="Search menu…"
              value={menuSearch}
              onChange={(e) => setMenuSearch(e.target.value)}
              aria-label="Search navigation"
            />
          </div>
        </div>
        <hr className="horizontal dark mt-0 mb-2" />
        <div
          className="collapse navbar-collapse w-auto"
          id="sidenav-collapse-main"
        >
          <section className="routes">
            <div className="nf-sidebar-section-label text-uppercase">Menu</div>
            <ul className="navbar-nav">
              {filteredRoutes.map((route, index) => (
                <li className="nav-item" key={`${route.path}-${index}`}>
                  <NavLink
                    to={route.path}
                    className={({ isActive }) =>
                      `nav-link d-flex align-items-center${isActive ? " active" : ""}`
                    }
                    onClick={closeSidebar}
                  >
                    <div className="icon me-2">{route.icon}</div>
                    {isOpen && <div className="link_text">{route.name}</div>}
                  </NavLink>
                </li>
              ))}
            </ul>
          </section>
        </div>
      </aside>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
        <Navbar />
        <div className="container-fluid py-2">{children}</div>
      </main>
    </>
  );
};

export default SideBar;
